import {
  Button, Collapse, Paper, Stack, Typography,
} from '@mui/material';
import React, {
  useEffect,
  useState,
} from 'react';
import dayjs from 'dayjs';
import Row from 'components/Row';
import Skeleton from 'components/Skeleton';
import { env } from 'constants';

function MerchantCard({
  merchant, isSelected, sx, loading, ...props
}) {
  const id = `merchant-card-${merchant?.id}`;
  const path = merchant ? `https://${merchant.slug}${env.APP_ENV !== 'production' ? '.stage' : ''}.caterlocally.com` : null;
  const [showTimes, setShowTimes] = useState(false);
  useEffect(() => {
    if (isSelected) {
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected]);

  if (!merchant) {
    return null;
  }
  return (
    <Stack
      component={Paper}
      key={merchant.id}
      id={id}
      sx={{
        cursor: 'pointer',
        p: 2,
        backgroundColor: isSelected ? 'background.elevation1' : undefined,
        borderColor: isSelected ? 'text.primary' : undefined,
        ...sx,
      }}
      variant="outlined"
      gap={2}
      {...props}
    >
      <Typography variant="title-md">{merchant.name}</Typography>
      <Typography variant="body-overline">{merchant.address}</Typography>
      {
        merchant.availability && (
          <>
            <Typography variant="body-md">
              First available time:
              {' '}
              {dayjs(merchant.availability.first_available_time).format('MMMM D, hh:mm a')}
            </Typography>
            <Collapse in={showTimes}>
              {
                Object.entries(merchant.availability?.schedule ?? {}).map(([day, hours]) => (
                  <Row key={day} mt={1}>
                    <Typography variant="label-md">{day}</Typography>
                    <div>
                      {
                        hours.map((h) => (
                          <Typography variant="body-md" key={h.from_hour}>
                            {h.from_hour}
                            {' '}
                            -
                            {' '}
                            {h.to_hour }
                          </Typography>
                        ))
                      }
                    </div>
                  </Row>
                ))
              }
            </Collapse>
          </>
        )
      }

      <Row gap="10px">
        <Button
          size="small"
          fullWidth
          onClick={() => setShowTimes((c) => !c)}
          disabled={loading}
          variant="link"
          sx={{ visibility: loading ? 'hidden' : 'visible' }}
        >

          {showTimes ? 'Hide available time' : 'View available time'}
        </Button>
        <Button
          component="a"
          variant="primary"
          size="small"
          fullWidth
          href={path}
          disabled={loading}
          sx={{ visibility: loading ? 'hidden' : 'visible' }}
          target="_blank"
          rel="noopener"
        >
          Order now
        </Button>
      </Row>

    </Stack>
  );
}
function MerchantCardSkeleton() {
  return (
    <Skeleton>
      <MerchantCard
        merchant={Skeleton.props({
          name: ['string', { length: 20 }],
          address: ['string', { length: 40 }],
        })}
        loading
      />
    </Skeleton>
  );
}

export default Skeleton.withSkeleton(MerchantCard, MerchantCardSkeleton);
